module.exports = __webpack_public_path__ + "img/NCC-fountain.a5982a31.jpg";